export const genderOptions = [
  { key: 'm', text: 'Herr', value: 'male' },
  { key: 'f', text: 'Frau', value: 'female' },
  { key: 'dr', text: 'Dr.', value: 'dr' },
  { key: 'prof', text: 'Prof.', value: 'prof' }
]

export const manufacturerOptions = [
  { key: 'nl', text: 'Nicht gelistet', value: 'notListed' },
  { key: 'ca', text: 'Canon', value: 'canon' },
  { key: 'ce', text: 'Celestron', value: 'celestron' },
  { key: 'cu', text: 'Cullmann', value: 'cullmann' },
  { key: 'dj', text: 'Dji', value: 'dji' },
  { key: 'do', text: 'Dörr', value: 'doerr' },
  { key: 'ev', text: 'Evoc', value: 'evoc' },
  { key: 'fu', text: 'Fuji', value: 'fuji' },
  { key: 'gl', text: 'Globell', value: 'globell' },
  { key: 'ham', text: 'Hama', value: 'hama' },
  { key: 'has', text: 'Hasselblad', value: 'hasselblad' },
  { key: 'ka', text: 'Kaiser', value: 'kaiser' },
  { key: 'le', text: 'Leica', value: 'leica' },
  { key: 'ma', text: 'Manfrotto', value: 'manfrotto' },
  { key: 'mu', text: 'Multiblitz', value: 'multiblitz' },
  { key: 'ni', text: 'Nikon', value: 'nikon' },
  { key: 'no', text: 'Novoflex', value: 'novoflex' },
  { key: 'ol', text: 'Olympus', value: 'olympus' },
  { key: 'pa', text: 'Panasonic', value: 'panasonic' },
  { key: 'pe', text: 'Pentax', value: 'pentax' },
  { key: 're', text: 'Reflecta', value: 'reflecta' },
  { key: 'ri', text: 'Ricoh', value: 'ricoh' },
  { key: 'ro', text: 'Rollei', value: 'rollei' },
  { key: 'si', text: 'Sigma', value: 'sigma' },
  { key: 'so', text: 'Sony', value: 'sony' },
  { key: 'st', text: 'Steiner', value: 'steiner' },
  { key: 'sw', text: 'Swarovski', value: 'swarovski' },
  { key: 'ta', text: 'Tamron', value: 'tamron' },
  { key: 'va', text: 'Vanguard', value: 'vanguard' },
  { key: 'yu', text: 'Yuneec', value: 'yuneec' },
  { key: 'ze', text: 'Zeiss', value: 'zeiss' }
]



// WEBPACK FOOTER //
// ./src/utils/Data.js